import { HStack, InputStepper, Text, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import React, { useEffect } from 'react';

import { FixedFeeAvailableConfigs } from '../../../../../../../store/fixedFee/types';
import { InputSkeleton } from '../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { MAX_RATE, MIN_RATE, RATE_STEP } from '../../../../constants';

interface ContractRateItemProps {
  rate: number;
  onRateChange: (value: number) => void;
  availableConfigs?: FixedFeeAvailableConfigs;
  loadingAvailableRateRanges: boolean;
}

export const ContractRateItem: React.FC<ContractRateItemProps> = ({
  rate,
  onRateChange,
  availableConfigs,
  loadingAvailableRateRanges,
}) => {
  const [hasFocus, setHasFocus] = React.useState(false);

  const minRate = availableConfigs?.minRate ?? MIN_RATE;
  const maxRate = availableConfigs?.maxRate ?? MAX_RATE;

  const getHelpText = () => {
    const minRateNormalize = Utils.Mask.Percentage(minRate);
    const maxRateNormalize = Utils.Mask.Percentage(maxRate);

    return `Digite um percentual entre ${minRateNormalize} e ${maxRateNormalize}`;
  };

  useEffect(() => {
    if (rate < minRate) {
      onRateChange(minRate);
    } else if (rate > maxRate) {
      onRateChange(maxRate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [minRate, maxRate]);

  return (
    <VStack space="stack.nano">
      <Text variant="semibold" color="neutral.darkest">
        Defina o percentual para o contrato
      </Text>

      <HStack alignItems="center" justifyContent="space-between">
        {loadingAvailableRateRanges ? (
          <InputSkeleton />
        ) : (
          <InputStepper
            onBlur={() => setHasFocus(false)}
            onFocus={() => setHasFocus(true)}
            defaultValue={rate}
            stepperValue={RATE_STEP}
            min={minRate}
            max={maxRate}
            name="fixed-fee-rate"
            onChange={onRateChange}
            maskOption="percentage"
            ignoreStepperDivision
            helpText={getHelpText()}
            helpTextProps={{
              color: hasFocus ? 'brand.tertiary.principal' : 'neutral.medium',
            }}
          />
        )}
      </HStack>
    </VStack>
  );
};
